import { useHttp } from '@/shared/lib'
import { useQuery } from '@tanstack/vue-query'
import { useRoute } from 'vue-router'
import { computed } from 'vue'

/**
 * Функция загрузки данных для виджета карты
 */
export const useLoadMapWidget = () => {
  const http = useHttp()
  const route = useRoute()

  const url = computed(() => `/objects/${route.params.object_id}/coordinates`)

  const queryKey = computed(() => ['load_map_widget', route.params.object_id])

  return useQuery({
    queryKey,
    queryFn: () => http.get(url.value),
    retry: false,
  })
}
